import { Component } from "@angular/core";
import { interval, Subscription } from "rxjs";
import { DiskUsage } from "src/app/core/models/diskUsage";
import { SystemInfo } from "src/app/core/models/healthSystemInfo";
import { MetricsInfo } from "src/app/core/models/metricsInfo";
import { HealthService } from "src/app/core/services/health.service";
import { SyncConfigService } from "src/app/core/services/sync-config.service";

@Component({
  selector: "app-health-system-info",
  templateUrl: "./health-system-info.component.html",
  styleUrl: "./health-system-info.component.scss",
})
export class HealthSystemInfoComponent {
  systemInfoDetails: SystemInfo;
  metricsInfo: MetricsInfo;
  diskUsage: DiskUsage;
  dataReloadSubscription: Subscription;

  constructor(
    private healthService: HealthService,
    public syncConfig: SyncConfigService
  ) {}

  ngOnInit(): void {
    this.getHostSystemInfo();
    this.getHostMetricsInfo();
    this.getHostDiskUsage();
    this.startDataReloadSub();
  }

  getHostSystemInfo() {
    this.healthService.getHostSystemInfo().subscribe({
      next: (data: any) => {
        this.systemInfoDetails = <SystemInfo>JSON.parse(JSON.stringify(data));
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  getHostMetricsInfo() {
    this.healthService.getHostMetricsInfo().subscribe({
      next: (data: any) => {
        this.metricsInfo = <MetricsInfo>JSON.parse(JSON.stringify(data));
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  getHostDiskUsage() {
    this.healthService.getHostDiskUsage().subscribe({
      next: (data: any) => {
        this.diskUsage = <DiskUsage>JSON.parse(JSON.stringify(data));
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  startDataReloadSub() {
    this.dataReloadSubscription = interval(
      this.syncConfig.config.healthService.dataReqInterval
    ).subscribe(async () => {
      await this.getHostSystemInfo();
      await this.getHostMetricsInfo();
      await this.getHostDiskUsage();
    });
  }
}
